<template>
  <BaseLottie
    :path="
      media === 'Mobile'
        ? require('@/assets/lottie/buy-now-mobile.json')
        : require('@/assets/lottie/buy-now-desktop.json')
    "
    :loop="false"
  />
</template>

<script>
import BaseLottie from '@/components/BaseLottie/BaseLottie'
import getMediaOnLoad from '@/mixins/getMediaOnLoad'
export default {
  mixins: [ getMediaOnLoad ],
  components: {
    BaseLottie
  }
}
</script>
